var render = function render(){var _vm=this,_c=_vm._self._c;return _c('match-media',{scopedSlots:_vm._u([{key:"default",fn:function({ mobile }){return [_c('footer',{class:_vm.classContentFooter},[(mobile && _vm.isNavigation)?_c('navigation-pills'):_c('social',{attrs:{"is-authenticate":_vm.isAuthenticate}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }